const InvoiceTransactions = () => {
	return <div>InvoiceTransactions</div>;
};

export default InvoiceTransactions;
